import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { CircularProgress } from '@mui/material';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import React from 'react';
import { string } from 'prop-types';

export type ButtonProps = MuiButtonProps & {
  circular?: boolean;
  isLoading?: boolean;
  size?: string;
  target?: string;
};

export const Button = ({
  circular,
  isLoading,
  children,
  disabled,
  size,
  target,
  ...props
}: ButtonProps) => {
  return (
    <MuiButton
      {...props}
      fullWidth={props.fullWidth ?? true}
      variant={props.variant ?? 'contained'}
      size={size ?? 'large'}
      disabled={disabled ?? isLoading}
      startIcon={
        (isLoading || props.startIcon) && (
          <div className="flex items-center">
            {isLoading ? (
              <CircularProgress size="1.66rem" className="ml-2" />
            ) : (
              props.startIcon
            )}
          </div>
        )
      }
      LinkComponent={React.forwardRef(function link(props, ref) {
        return <Link {...props} ref={ref} to={props.href} target={target} />;
      })}
      className={clsx(
        'font-bold',
        { 'rounded-full': circular },
        props.className
      )}
    >
      {!isLoading && children}
    </MuiButton>
  );
};

Button.propTypes = {
  href: string,
};
